// @flow
import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'

import { myTheme } from '../../../styles'

const { space, breakpoint } = myTheme

/*
  Negate's the parent OuterContainer

  Usage:

  One Side:
    <NegateOuterContainer
      side="left|right|both (default)
      breakpoint={breakpoint.small}
    >
      <Element />
    </div>

  Both Sides:
    <NegateOuterContainer>
      <Element />
    </div>

*/

const Base = styled.div`
  ${props =>
    (props.side === 'left' || props.side === 'both') &&
    `margin-left: -${space.three};`};
  ${props =>
    (props.side === 'right' || props.side === 'both') &&
    `margin-right: -${space.three};`};
`
const Small = styled.div`
  @mediaQueryTarget screen and (min-width: ${breakpoint.small}) {
    ${props =>
    (props.side === 'left' || props.side === 'both') &&
      `margin-left: -${space.three};`};
    ${props =>
    (props.side === 'right' || props.side === 'both') &&
      `margin-right: -${space.three};`};
  }
`
const Medium = styled.div`
  @media screen and (min-width: ${breakpoint.medium}) {
    ${props =>
    (props.side === 'left' || props.side === 'both') &&
      `margin-left: -${space.four};`};
    ${props =>
    (props.side === 'right' || props.side === 'both') &&
      `margin-right: -${space.four};`};
  }
`
const Large = styled.div`
  @media screen and (min-width: ${breakpoint.large}) {
    ${props =>
    (props.side === 'left' || props.side === 'both') &&
      `margin-left: -${space.five};`};
    ${props =>
    (props.side === 'right' || props.side === 'both') &&
      `margin-right: -${space.five};`};
  }
`

type Props = {
  side?: 'left' | 'right' | 'both',
  children: Node,
  mediaQueryTarget?: 'small' | 'medium' | 'large',
}

const NegateOuterContainer = ({ side, children, mediaQueryTarget }: Props) => {
  if (mediaQueryTarget === 'small') {
    return <Small side={side}>{children}</Small>
  } else if (mediaQueryTarget === 'medium') {
    return <Medium side={side}>{children}</Medium>
  } else if (mediaQueryTarget === 'large') {
    return <Large side={side}>{children}</Large>
  }
  return <Base side={side}>{children}</Base>
}
NegateOuterContainer.defaultProps = {
  side: 'both',
  mediaQueryTarget: 0,
}

export default NegateOuterContainer



// WEBPACK FOOTER //
// ./src/components/helpers/outer-container/negate-outer-container.js